<template>
<div id="participant-list">
    <label
      class="control-label mb-10 text-left" style="font-weight: bold;"
    >{{ $t(`app.inspections.attributes.inspection_participants`) }}</label>
    <multiselect v-model="formedParticipants" 
      :options="formedWorkers" 
      :multiple="true"
      :selectLabel="$t('app.multiselect.select')"
      :selectedLabel="$t('app.multiselect.selected')"
      :deselectLabel="$t('app.multiselect.remove')"
      :close-on-select="false" 
      :clear-on-select="false" 
      :preserve-search="true" 
      :placeholder="$t(`app.inspections.participant_search_input_placeholder`)" 
      label="name" 
      track-by="id" 
      :preselect-first="false"
      @input="participantsChanged">
      <span slot="noOptions">{{$t('app.generals.empty_list')}}</span>
      <template #noResult>
        {{$t('app.generals.empty_list')}}
      </template>
    </multiselect>
</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ConfigurableList from "@/components/shared/lists/ConfigurableList";
import BaseButton from "@/components/shared/buttons/BaseButton";
import VueTagsInput from "@johmun/vue-tags-input";


export default {
  name: "ParticipantList",
  components: {
    'configurable-list': ConfigurableList,
    'vue-tags-input': VueTagsInput,
    'base-button': BaseButton
	},
	props: {
		participants: {
      Type: Array,
      required: true,
    },
		workers: {
      Type: Array,
      required: true,
    }
	},
  data() {
    return {
      currentTagValue: "",
      title: this.$t("app.inspections.add_participants"),
      formedParticipants: [],
      formedWorkers: [],
      participantList: [],
      editable: true,
		};
  },
  created() {
    if(this.$route.name === 'InspectionReportScreen') {
      this.editable = false;
    }
    this.formedParticipants = this.participants.map(participant => {
      return {id: participant.id, name: participant.name}
    })
    this.formedWorkers = this.workers.map(worker => {
      return {id: worker.id, name: worker.name}
    })
  },
  computed: {
    ...mapGetters({
      loggedInUser: "loggedInUser"
    }),
  },
  methods: {
    filteredList(list,tag) {
      if(list) {
        return list.filter(i => {
          return i.text.toLowerCase().indexOf(tag.toLowerCase()) !== -1;
        });
      }
    },
    participantsChanged(participants) {
      // this.participants = participants;
      const participantIds = [];
      participants.forEach(x => {
        participantIds.push(x.id)
      })
      this.$emit("updateParticipants",participantIds)
    },
  },
  watch: {
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
#participant-list {
  margin: 0 -9px;
  .name-cell {
    width: 15%;
  }

  .user-name-cell {
    width: 15%;
  }

  .email-cell {
    width: 20%;
  }

  .phone-cell {
    width: 20%;
  }

  .job-cell {
    width: 20%;
  }

  .edit-cell {
    width: 5%;
  }

  .delete-cell {
    width: 5%;
  }

  .vue-tags-input {
    max-width: 100%;
    margin-bottom: 20px;
  }
  & /deep/ .ti-input {
    border: none;
  }
  & /deep/ .ti-tag {
    background-color: var(--main-color);
  }
  & /deep/ .ti-deletion-mark {
    background-color: #ee234f !important;
  }
  & /deep/ .ti-tag:before {
    display: none;
  }

  /deep/ .multiselect__tag {
    background: var(--main-color);
  }

  /deep/ .multiselect__tags {
    margin-bottom: 20px;
  }

  /deep/ .multiselect__tag-icon:hover {
    background: var(--main-color);
  }

  /deep/ .multiselect__tag-icon:after {
    color: #000;
  }

  /deep/ .multiselect__option--highlight {
    background: #ff61289f;
  }
}

/deep/ .multiselect__option--highlight:after {
  background: none;
}

/deep/ .multiselect__option--selected.multiselect__option--highlight:after {
  background: none;
}

/deep/ .multiselect__option--selected.multiselect__option--highlight {
    background: #ff282873 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/inspections/ParticipantList.vue